import { z } from 'zod';
import { createLocalizedTextSchema } from './merchant-content.js';
import { publicTypographyPackSchema } from './public-page-design.js';
export const websiteTemplateIdSchema = z.enum([
    'salon', 'barber', 'padel', 'fitness', 'clinic', 'photography', 'consulting',
    'workshops', 'dental', 'pet-grooming', 'car-detailing', 'coworking', 'events',
]);
const color = z.string().regex(/^#[0-9a-fA-F]{6}$/);
/** Website-only appearance lives with each draft, published and restored version. */
export const storefrontDesignSchema = z.object({
    templateId: websiteTemplateIdSchema.optional(),
    accentColor: color.optional(),
    backgroundColor: color.optional(),
    textColor: color.optional(),
    typographyPack: publicTypographyPackSchema.optional(),
    businessName: createLocalizedTextSchema(100).optional(),
    description: createLocalizedTextSchema(500).optional(),
    bookingLabel: createLocalizedTextSchema(40).optional(),
    bookingServiceId: z.uuid().nullable().optional(),
    coverSource: z.enum(['business', 'template', 'upload', 'none']).optional(),
    coverFileId: z.uuid().nullable().optional(),
    logoSource: z.enum(['business', 'upload', 'none']).optional(),
    logoFileId: z.uuid().nullable().optional(),
    coverPosition: z.number().int().min(0).max(100).optional(),
    publicPhone: z.string().trim().max(40).optional(),
    publicEmail: z.union([z.literal(''), z.email().max(254)]).optional(),
    publicAddress: z.string().trim().max(300).optional(),
    defaultLocale: z.enum(['ar', 'en', 'de', 'nl']).optional(),
    enabledLocales: z.array(z.enum(['ar', 'en', 'de', 'nl'])).min(1).max(4).optional(),
    hideBranding: z.boolean().optional(),
    showServices: z.boolean().optional(),
    showResources: z.boolean().optional(),
}).strict().superRefine((design, context) => {
    if (design.coverSource === 'upload' && !design.coverFileId)
        context.addIssue({ code: 'custom', path: ['coverFileId'], message: 'Choose an uploaded cover image.' });
    if (design.logoSource === 'upload' && !design.logoFileId)
        context.addIssue({ code: 'custom', path: ['logoFileId'], message: 'Choose an uploaded logo.' });
    if (design.defaultLocale && design.enabledLocales && !design.enabledLocales.includes(design.defaultLocale))
        context.addIssue({ code: 'custom', path: ['enabledLocales'], message: 'Include the default language.' });
});
//# sourceMappingURL=storefront-design.js.map